module.exports = __webpack_public_path__ + "img/lootbox-epic.28baeda4.jpg";